/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled, { css } from "styled-components";
import { Text, theme } from "@nordcloud/gnui";
import { Box as BoxContainer } from "~/components/Styled";

function getInteractiveCss() {
  return css`
    cursor: pointer;

    &:hover {
      background-color: ${theme.color.background.ui04};
    }
  `;
}

type StyledBoxProps = Omit<Props, "icon" | "label">;

const StyledBox = styled(BoxContainer)<StyledBoxProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background-color: ${theme.color.background.ui03};
  min-height: calc(100% - 2rem);

  ${({ onClick }) => onClick && getInteractiveCss()};
`;

type Props = React.HTMLAttributes<HTMLDivElement> & {
  label?: string;
  icon?: React.ReactNode;
  onClick?: () => void;
};

export function IconBox({ onClick, icon, label, ...rest }: Props) {
  return (
    <StyledBox border={theme.color.border.border01} onClick={onClick} {...rest}>
      {icon}
      {label && (
        <Text size="md" marginTop={theme.spacing.spacing06} weight="medium">
          {label}
        </Text>
      )}
    </StyledBox>
  );
}
